import React, { useEffect, useState } from 'react';
import { catalogApi } from '../../api/catalog';

export default function BAQuestionsAdmin() {
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ category: '', question: '', sort_order: 99 });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    loadQuestions();
  }, []);

  const loadQuestions = async () => {
    try {
      const response = await catalogApi.getQuestions();
      setQuestions(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    try {
      await catalogApi.createQuestion(formData);
      setShowForm(false);
      setFormData({ category: '', question: '', sort_order: 99 });
      loadQuestions();
    } catch (err) {
      alert('Error al crear pregunta');
    }
  };

  const handleToggle = async (q) => {
    try {
      await catalogApi.updateQuestion(q.id, { is_active: !q.is_active });
      loadQuestions();
    } catch (err) {
      console.error(err);
    }
  };

  const handleDelete = async (qId) => {
    if (!window.confirm('¿Eliminar pregunta?')) return;
    try {
      await catalogApi.deleteQuestion(qId);
      loadQuestions();
    } catch (err) {
      alert('Error al eliminar');
    }
  };

  const categories = [...new Set(questions.map((q) => q.category))];

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Preguntas del Analista BA</h1>
          <p className="text-sm text-gray-500">Catálogo de preguntas para el wizard de entrevista.</p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm font-medium"
        >
          + Nueva Pregunta
        </button>
      </div>

      {showForm && (
        <div className="bg-white rounded-xl border border-gray-200 p-6">
          <form onSubmit={handleCreate} className="space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <input
                type="text"
                placeholder="Categoría (ej: Contexto, Funcionalidad...)"
                value={formData.category}
                onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                required
                list="categories"
              />
              <datalist id="categories">
                {categories.map((c) => <option key={c} value={c} />)}
              </datalist>
              <input
                type="number"
                placeholder="Orden"
                value={formData.sort_order}
                onChange={(e) => setFormData({ ...formData, sort_order: parseInt(e.target.value) || 99 })}
                className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
                min="1"
              />
              <div className="flex gap-2">
                <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm">Crear</button>
                <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 bg-gray-200 rounded-lg text-sm">Cancelar</button>
              </div>
            </div>
            <textarea
              placeholder="Pregunta..."
              value={formData.question}
              onChange={(e) => setFormData({ ...formData, question: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 outline-none"
              rows={2}
              required
            />
          </form>
        </div>
      )}

      {/* Questions grouped by category */}
      {categories.map((category) => (
        <div key={category} className="bg-white rounded-xl border border-gray-200 overflow-hidden">
          <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
            <h3 className="font-semibold text-gray-700">{category}</h3>
          </div>
          <div className="divide-y divide-gray-100">
            {questions.filter((q) => q.category === category).map((q) => (
              <div key={q.id} className="px-4 py-3 flex items-center justify-between hover:bg-gray-50">
                <div className="flex items-center gap-3 flex-1">
                  <span className="text-xs text-gray-400 w-6">{q.sort_order}</span>
                  <span className={`text-sm ${q.is_active ? 'text-gray-700' : 'text-gray-400 line-through'}`}>
                    {q.question}
                  </span>
                </div>
                <div className="flex items-center gap-2">
                  <button
                    onClick={() => handleToggle(q)}
                    className={`px-2 py-1 rounded text-xs ${q.is_active ? 'bg-green-100 text-green-700' : 'bg-gray-100 text-gray-500'}`}
                  >
                    {q.is_active ? 'Activa' : 'Inactiva'}
                  </button>
                  <button
                    onClick={() => handleDelete(q.id)}
                    className="px-2 py-1 text-xs text-red-500 hover:text-red-700"
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
